
import * as React from 'react';
import Table from '../../uiComponents/table/Table';
import { TableHeaderColumn } from 'react-bootstrap-table';
import TableFormatters from '../../uiComponents/table/TableFormatters';
import { RoundLink } from '../../uiComponents/input/Buttons';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';

export interface KonkurrenceTilLaererEksternTableProps {
    konkurrencer?: any[];
}

export default class KonkurrenceTilLaererEksternTable extends React.Component<KonkurrenceTilLaererEksternTableProps, any> {
    constructor(props: KonkurrenceTilLaererEksternTableProps) {
        super(props);
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    ekstraLaerereFormatter(cell: any, row: any) {
        if (cell === undefined) {
            return '';
        } else {
            return cell.join(', ');
        }
    }

    rowButtons(cell: any, row: any) {
        let editLink = '/tilmelding/rediger/' + row.tilmeldingId;

        return (
            <div className='table-controls'>
                <RoundLink className='edit-tilmelding-button' href={editLink} iconName='edit' tooltip='Se/rediger tilmelding' tooltipPlacement='bottom' />
            </div>
        );
    }

    getTableContent() {
        const bruger = getLoggedInBruger();
        if (bruger.rolle === BrugerRolleEnum.Laerer) {
            return (
                <Table data={this.props.konkurrencer} emptyText='Du er endnu ikke tilmeldt en konkurrence'>
                    <TableHeaderColumn dataField='id' isKey={true} hidden={true} dataAlign='center' />
                    <TableHeaderColumn dataField='tilmeldingId' hidden={true} dataAlign='center' />
                    <TableHeaderColumn width='100' dataField='dato' className='first' columnClassName='first' dataFormat={TableFormatters.dateFormatter} dataSort={true}>Dato</TableHeaderColumn>
                    <TableHeaderColumn dataField='skole' dataSort={true}>Skole</TableHeaderColumn>
                    <TableHeaderColumn width='100' dataField='hold' dataSort={true}>Hold</TableHeaderColumn>
                    <TableHeaderColumn dataField='konkurrenceTitel' dataSort={true}>Konkurrence</TableHeaderColumn>
                    <TableHeaderColumn dataField='ansvarligLaerer' dataSort={true}>Ansvarlig lærer</TableHeaderColumn>
                    <TableHeaderColumn dataField='ekstraLaerere' dataFormat={this.ekstraLaerereFormatter} dataSort={true}>Ekstra lærere</TableHeaderColumn>
                    <TableHeaderColumn dataField='paaVenteliste' dataFormat={TableFormatters.tilmeldingStatusFormatter} dataSort={true}>Status</TableHeaderColumn>
                    <TableHeaderColumn width='75' dataFormat={this.rowButtons} className='table-menu' columnClassName='table-menu' />
                </Table>
            );
        } else {
            return (
                <Table data={this.props.konkurrencer} emptyText='Du er endnu ikke tilmeldt en konkurrence'>
                    <TableHeaderColumn dataField='id' isKey={true} hidden={true} dataAlign='center' />
                    <TableHeaderColumn width='200' dataField='dato' className='first' columnClassName='first' dataFormat={TableFormatters.dateFormatter} dataSort={true}>Dato</TableHeaderColumn>
                    <TableHeaderColumn dataField='konkurrenceTitel' dataSort={true}>Konkurrence</TableHeaderColumn>
                </Table>
            );

        }
    }

    render() {
        return this.getTableContent();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceTilLaererEksternTable.tsx